import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { ConfirmationPageSettingsFragment } from "__generated__/graphql";
import { useTranslation } from "react-i18next";
import { redirectToTargetUrl } from "./helpers/redirectToTargetUrl";
// import { FormRedirectionPage } from "./FormRedirectionPage";

interface IConfirmationPageProps {
  confirmationPageSettings: ConfirmationPageSettingsFragment | null;
}
export const ConfirmationPage: React.FC<IConfirmationPageProps> = ({
  confirmationPageSettings,
}) => {
  const { t: translate } = useTranslation("form_builder");
  useEffect(() => {
    if (confirmationPageSettings?.redirectUrl) {
      setTimeout(() => {
        redirectToTargetUrl({
          redirectUrl: confirmationPageSettings.redirectUrl,
        });
      }, 1000);
    }
  }, [confirmationPageSettings?.redirectUrl]);
  return (
    // we cannot use feature flag in unauthenticated form
    // so uncomment this when we use rich text field for confirmation page
    // and please collaborate with QA team when merge this change

    // <FormRedirectionPage
    //   header={
    //     confirmationPageSettings?.thankYouHeader ||
    //     translate("forms.confirmation.thank_you")
    //   }
    //   message={
    //     confirmationPageSettings?.thankYouMessage ||
    //     translate("forms.confirmation.default_message")
    //   }
    //   redirectUrl={confirmationPageSettings?.redirectUrl}
    // />
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: (theme) => theme.palette.background.lightBlue,
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          background: (theme) => theme.palette.common.white,
          p: 4,
        }}
      >
        <Typography variant="h4">
          {confirmationPageSettings?.thankYouHeader ||
            translate("forms.confirmation.thank_you")}
        </Typography>
        <Typography mt={2}>
          {confirmationPageSettings?.thankYouMessage ||
            translate("forms.confirmation.default_message")}
        </Typography>
        {confirmationPageSettings?.redirectUrl && (
          <Typography mt={4}>
            {translate("forms.confirmation.redirect_message")}{" "}
            <a href={confirmationPageSettings.redirectUrl}>
              {confirmationPageSettings.redirectUrl}
            </a>
            .
          </Typography>
        )}
        <Box
          sx={{
            mt: 4,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" color="grey.900">
            {translate("forms.confirmation.nexl_branding")}{" "}
            <a href="https://nexl.cloud/">Nexl</a>{" "}
            {translate("forms.confirmation.learn_more")}.
          </Typography>
          <img height={16} src="/images/nexl_logo.svg" alt="go to home" />
        </Box>
      </Box>
    </Box>
  );
};
